(function(){
  var events = [
    'templateDecorationChanged',
    'themeChanged',
    'primaryColorChanged',
    'secondaryColorChanged',
    'themeRowColorChanged'
  ];

  Em.View.reopen({
    didInsertElement: function(){
      this._super();
      if ( ! this.get('boundEvents') || !this.get('boundEvents').length ) { return; }
      events.forEach(function(event){
        if ( this.get( 'boundEvents' ).contains(event) ) {
          $(window).on([event,this.get('elementId')].join('.'), this[event].bind(this, event));
        }
      }, this);
    },
    willDestroyElement: function(){
      this._unbindAll();
      this._super();
    },
    _unbindAll: function(){
      events.forEach(function(event){
        $(window).off([event, this.get('elementId')].join('.'));
      }, this);
    }
  });
})();

// TODO the modal needs this for some reason in rendering nested view selects.  Retest after upgrade.
// UPDATE still needed at Em 1.0 proper
(function(){
  var get = Em.get;

  Em.Select.reopen({
    _changeSingle: function(){
      if ( !this.$().length ) { return; }
      this._super();
    },
    valueDidChange: Ember.observer(function() {
      var content = get(this, 'content'),
          value = get(this, 'value'),
          valuePath = get(this, 'optionValuePath').replace(/^content\.?/, ''),
          selectedValue = (valuePath ? get(this, 'selection.' + valuePath) : get(this, 'selection')),
          selection;

      if ( !content ) { return; }

      if (value !== selectedValue) {
        selection = content.find(function(obj) {
          return value === (valuePath ? get(obj, valuePath) : obj);
        });

        this.set('selection', selection);
      }
    }, 'value')
  });

})();
